import { render, staticRenderFns } from "./SupplierNavigation.vue?vue&type=template&id=686d5f6e&"
import script from "./SupplierNavigation.vue?vue&type=script&lang=js&"
export * from "./SupplierNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports